import type { Task } from '@frontend/api-types';
import { Text, YStack } from '@frontend/web-react';
import { EmptyReviewTasks } from './EmptyReviewTasks';
import { ReviewTaskCard } from './ReviewTaskCard';

type ReviewTasksContainerProps = {
  tasks: Task[];
};

export const ReviewTasksContainer = ({ tasks }: ReviewTasksContainerProps) => (
  <YStack className="gap-sm">
    <Text type="h4">Ready for review {tasks.length ? `(${tasks.length})` : ''}</Text>
    {tasks.length ? (
      <YStack className="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
        {tasks.map((task) => (
          <ReviewTaskCard key={task.id} task={task} />
        ))}
      </YStack>
    ) : (
      <EmptyReviewTasks />
    )}
  </YStack>
);
